module.exports = __webpack_public_path__ + "media/images/Gold_PlayNext-d04d8e470388b69b30ea47e38373191b.png";